import { Component, OnInit } from '@angular/core';
import { AuthResponse, AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { UtilitieService } from 'src/app/services/utils/utilities.service';

@Component({
  selector: 'reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit{

  password: string;
  confirmPassword: string;
  private authResponse: AuthResponse;

  show: boolean = false;
  show2: boolean = false;

  constructor(private authService: AuthService, private router: Router, private utilService: UtilitieService){
    this.password = '';
    this.confirmPassword = '';
  }

  toggle(){
    if(this.show){
      this.show = false;
    }else{
      this.show = true;
    }
  }

  toggle2(){
    if(this.show2){
      this.show2 = false;
    }else{
      this.show2 = true;
    }
  }


  async resetPassword(){

    
    let result: boolean = await this.authService.passwordReset(this.password, this.confirmPassword, this.authResponse);
    if(result){
      this.authService.openSnackBar('Password reset', '');
      this.router.navigate(['/']);
      this.authService.logout();
      return;
    }

    this.authService.openSnackBar('There was an issue updating password', 'Request may have expired');
  }

  async ngOnInit(): Promise<void> {
    this.utilService.updateLoading(true);
    this.authResponse = await this.authService.getVerificationToken();
    if(!this.authResponse){
      this.authService.openSnackBar('Error reading token','Please try again');
      this.router.navigate(['/']);
    }
    this.utilService.updateLoading(false);
  }

}
